import React from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { CustomAlert } from "@/components/ThemedAlert";
import { ThemedText } from "@/components/ThemedText";
import { ThemedButton } from "@/components/ThemedButton";
import ThemedScreen from "@/components/ThemedScreen";
import { ThemedView } from "@/components/ThemedView";
import { router } from "expo-router";

export default function TestAlertScreen() {
  return (
    <ThemedScreen
      title="Alert System Test"
      leftIcon={{
        name: "arrow-back",
        onPress: () => router.navigate("/admin/test" as any),
      }}
    >
      <ScrollView style={styles.container}>
        <ThemedView style={styles.section}>
          <ThemedText type="subtitle">Basic Alerts</ThemedText>
          <View style={styles.buttonGrid}>
            <ThemedButton title="Simple Alert" onPress={() => CustomAlert.alert("Hello", "This is a simple alert message.")} />
            <ThemedButton
              title="Long Message"
              onPress={() =>
                CustomAlert.alert(
                  "Terms and Conditions",
                  "This is a very long message to test how the alert handles multi-line text and overflow. It should wrap nicely and the container should adjust its height accordingly to maintain a premium feel. We want to ensure that even with significant amounts of text, the typography remains legible and the overall balance of the UI is preserved.",
                )
              }
            />
          </View>
        </ThemedView>

        <ThemedView style={styles.section}>
          <ThemedText type="subtitle">Button Layouts</ThemedText>
          <View style={styles.buttonGrid}>
            <ThemedButton title="1 Button (OK)" onPress={() => CustomAlert.alert("Notice", "Your session will expire in 5 minutes.")} />
            <ThemedButton
              title="2 Buttons (Horizontal)"
              onPress={() =>
                CustomAlert.alert("Confirm Action", "Are you sure you want to proceed?", [
                  { text: "Cancel", style: "cancel" },
                  { text: "Confirm", onPress: () => console.log("Confirmed") },
                ])
              }
            />
            <ThemedButton
              title="3+ Buttons (Vertical)"
              onPress={() =>
                CustomAlert.alert("Select Action", "What would you like to do with this memory?", [
                  { text: "Save to Archive", onPress: () => console.log("Archived") },
                  { text: "Share with Family", onPress: () => console.log("Shared") },
                  { text: "Delete Permanently", style: "destructive", onPress: () => console.log("Deleted") },
                  { text: "Cancel", style: "cancel" },
                ])
              }
            />
          </View>
        </ThemedView>

        <ThemedView style={styles.section}>
          <ThemedText type="subtitle">Special Options</ThemedText>
          <View style={styles.buttonGrid}>
            <ThemedButton
              title="Destructive Alert"
              onPress={() =>
                CustomAlert.alert("Delete Account", "This action is permanent and cannot be undone.", [
                  { text: "Keep Account", style: "cancel" },
                  { text: "Delete Everything", style: "destructive", onPress: () => console.log("Account Deleted") },
                ])
              }
            />
            <ThemedButton
              title="Non-Cancelable"
              onPress={() =>
                CustomAlert.alert("Update Required", "You must update the app to continue using it.", [{ text: "Update Now", onPress: () => console.log("Updating...") }], { cancelable: false })
              }
            />
          </View>
        </ThemedView>

        <ThemedView style={styles.section}>
          <ThemedText type="subtitle">Visual Stress Test</ThemedText>
          <View style={styles.buttonGrid}>
            <ThemedButton
              title="Very Long Buttons"
              onPress={() =>
                CustomAlert.alert("Stress Test", "Testing buttons with extremely long text labels.", [
                  { text: "This is a button with a really long label to see if it wraps", onPress: () => {} },
                  { text: "Another long button label that might cause issues", onPress: () => {} },
                  { text: "Close", style: "cancel" },
                ])
              }
            />
            <ThemedButton
              title="Emoji Test"
              onPress={() => CustomAlert.alert("Emoji Support 🚀", "Testing emojis in title and message! ✨🎉📸\n\nHow does it look? 🌈", [{ text: "Awesome! 😎", onPress: () => {} }])}
            />
          </View>
        </ThemedView>
      </ScrollView>
    </ThemedScreen>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
  },
  section: {
    marginBottom: 24,
    padding: 16,
    borderRadius: 12,
    backgroundColor: "rgba(150, 150, 150, 0.05)",
    gap: 12,
  },
  buttonGrid: {
    gap: 10,
  },
});
